import HIK1DPositioningModal from './HIK_1D_positioning-modal.vue'
export default HIK1DPositioningModal
